export default ({
    state: {
        showLoading: false,
    },
    getters: {},
    mutations: {
        /*=============================================================================
        * setShowLoading
        * Controla a exibição do LOADING da Aplicação no component FormRight  
        =============================================================================*/
        setShowLoading(state, payload) {
            state.showLoading = payload
        },
    }
})
